import React, { useEffect, useState } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
export function Navigation() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const links = [{
    name: 'Leistungen',
    href: '/#leistungen'
  }, {
    name: 'Über mich',
    href: '/#ueber-mich'
  }, {
    name: 'Prozess',
    href: '/#prozess'
  }, {
    name: 'Förderungen',
    href: '/#foerderungen'
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${isScrolled ? 'bg-secondary/90 backdrop-blur-md py-4 shadow-sm' : 'bg-transparent py-6'}`} data-id="element-279">
      <div className="max-w-7xl mx-auto px-6 md:px-12 flex justify-between items-center" data-id="element-280">
        <a href="#" className="text-2xl font-serif font-medium tracking-wide text-accent z-50" data-id="element-281">
          henkel<span className="text-primary" data-id="element-282">·</span>energie
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-8" data-id="element-283">
          {links.map(link => <a key={link.name} href={link.href} className="text-sm font-medium text-accent/80 hover:text-primary transition-colors" data-id="element-284">
              {link.name}
            </a>)}
          <a href="/#kontakt" className="ml-4 px-6 py-2.5 bg-accent text-secondary text-sm font-medium rounded hover:bg-primary transition-colors duration-300" data-id="element-285">
            Kontakt
          </a>
        </nav>

        {/* Mobile Toggle */}
        <button className="md:hidden z-50 text-accent p-2 -mr-2" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-286">
          {isMobileMenuOpen ? <XIcon size={24} data-id="element-287" /> : <MenuIcon size={24} data-id="element-288" />}
        </button>

        {/* Mobile Menu */}
        <AnimatePresence data-id="element-289">
          {isMobileMenuOpen && <motion.div initial={{
          opacity: 0,
          y: -20
        }} animate={{
          opacity: 1,
          y: 0
        }} exit={{
          opacity: 0,
          y: -20
        }} transition={{
          duration: 0.3
        }} className="absolute top-0 left-0 right-0 bg-secondary h-screen pt-24 px-6 flex flex-col gap-8 md:hidden" data-id="element-290">
              {links.map(link => <a key={link.name} href={link.href} onClick={() => setIsMobileMenuOpen(false)} className="text-3xl font-serif text-accent" data-id="element-291">
                  {link.name}
                </a>)}
              <a href="/#kontakt" onClick={() => setIsMobileMenuOpen(false)} className="mt-4 px-8 py-4 bg-accent text-secondary text-center text-lg font-medium rounded hover:bg-primary transition-colors" data-id="element-292">
                Kontakt aufnehmen
              </a>
            </motion.div>}
        </AnimatePresence>
      </div>
    </header>;
}